import './PagesTitle.css';

interface Props {
  title: string;
}

export function PageTitle({ title }: Props) {
  return (
    <h1 className="page-title">
      {title}
    </h1>
  );
}